import { render } from "./LbrxInput.vue?vue&type=template&id=3f04e7b1&scoped=true"
import script from "./LbrxInput.vue?vue&type=script&lang=js"
export * from "./LbrxInput.vue?vue&type=script&lang=js"

import "./LbrxInput.vue?vue&type=style&index=0&id=3f04e7b1&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f04e7b1"]])

export default __exports__